import React from 'react'
import { Link } from 'react-router-dom'

function ActivityCard({ imgesThumb, title, details, username, price, time}) {
    return (
        <li className="activitySingleItems">
            <Link to="/user/username/asset"><img src={imgesThumb} alt="" className="itemThumb"/></Link>
            <ul className="activityItemDet">
                <li><h1><Link to="/user/username/asset">{title}</Link></h1></li>
                <li>{details} by <Link to="/user/username">{username}</Link></li>
                <li>for {price} ETH</li>
                <li><small>{time} minutes ago</small></li>
            </ul>
        </li>
    )
}

export default ActivityCard
